import styled from '@emotion/styled';
import {Checkbox, TextArea} from '@bosch/react-frok';

export const TextWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: small;
    margin-bottom: 0;
`;

export const TextInputLong = styled(TextArea)`
    margin-bottom: 0.5rem;
    justify-content: center;
    align-self: center;
    align-items: stretch;
`;

export const CheckboxStyled = styled(Checkbox)`
    padding-bottom: 1rem;
`;

export const HeaderWarning = styled.p`
    color: red;
    font-weight: bold;
    margin-top: 0;
    margin-bottom: 0;
`;

export const HeaderWarningDetails = styled.p`
    color: red;
    font-weight: normal;
    margin-top: 0;
    margin-bottom: 1rem;
    white-space: pre-line;
`;
